import { createAsyncThunk } from "@reduxjs/toolkit";
import overallReportingApi from "app/api/overallReporting";
import moment from "moment";

// Get Credit Movement Listing
export const getCreditMovementListing = createAsyncThunk(
  "reporting/getCreditMovementListing",
  async (payload, thunkApi) => {
    return overallReportingApi
      .getCreditMovementListing({
        start_date: payload.start_date
          ? moment(payload.start_date).format("YYYY-MM-DD")
          : null,
        end_date: payload.end_date
          ? moment(payload.end_date).format("YYYY-MM-DD")
          : null,
        product_sku: payload.product_sku,
        search: payload.search,
        start: payload.start,
        length: payload.length,
      })
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Get Product SKU List
export const getProductSkuList = createAsyncThunk(
  "reporting/getProductSkuList",
  async (_, thunkApi) => {
    return overallReportingApi
      .getProductSkuList()
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);
